import {createAction} from 'web-app/util/redux/famly-app-helpers';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

const domain = 'MODALS/NEW_CONTACT';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (childId: string, behaviors: BehaviorsCollection, usePincodeCheckin: boolean, institutionId: string) => {
        return {
            childId,
            behaviors,
            usePincodeCheckin,
            institutionId,
        };
    },
);

export const {action: close} = createAction(`${domain}/CLOSE`, () => ({}));
